import { render, staticRenderFns } from "./navigation-sub-button.vue?vue&type=template&id=808f8264&scoped=true"
import script from "./navigation-sub-button.vue?vue&type=script&lang=ts"
export * from "./navigation-sub-button.vue?vue&type=script&lang=ts"
import style0 from "./navigation-sub-button.vue?vue&type=style&index=0&id=808f8264&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808f8264",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('808f8264')) {
      api.createRecord('808f8264', component.options)
    } else {
      api.reload('808f8264', component.options)
    }
    module.hot.accept("./navigation-sub-button.vue?vue&type=template&id=808f8264&scoped=true", function () {
      api.rerender('808f8264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/layout/navigation-sub-button.vue"
export default component.exports